"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canWorldCharacterTurnInQuest = void 0;
const Quest_1 = require("../classes/Quest");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const definables_1 = require("definables");
const canWorldCharacterTurnInQuest = (worldCharacterID, questID) => {
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
    const questInstance = worldCharacter.questInstances[questID];
    if (typeof questInstance === "undefined") {
        return false;
    }
    const quest = (0, definables_1.getDefinable)(Quest_1.Quest, questID);
    if (typeof questInstance.monsterKills !== "undefined") {
        if (questInstance.monsterKills < quest.monster.kills) {
            return false;
        }
    }
    return true;
};
exports.canWorldCharacterTurnInQuest = canWorldCharacterTurnInQuest;
